import { IStoreMenu } from "@stores/StoreMenu";

export const handleToggle = (StoreMenu: IStoreMenu) => () => {
  StoreMenu.toggle();
};
